import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const MobileGamesRoutes: Routes = [
  {
    path: "mobile-games",
    loadComponent: () =>
      import("./mobile-games/mobile-games.component").then(
        (m) => m.MobileGamesComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./mobile-games-list/mobile-games-list.component").then(
            (m) => m.MobileGamesListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./mobile-games-form/mobile-games-form.component").then(
            (m) => m.MobileGamesFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./mobile-games-form/mobile-games-form.component").then(
            (m) => m.MobileGamesFormComponent,
          ),
      },
    ],
  },
];
